import { TaskStatus } from "@/consts/Task";
import { ReactComponent as DotSvg } from "@/assets/images/dot.svg";

type Props = {
  status: TaskStatus;
};

export default function TaskStatusLabel({ status }: Props) {
  const { label, color } = statusInfo[status];
  return (
    <div className={`flex items-center ${color}`}>
      <DotSvg className="fill-current" />
      <span className="text-xs font-semibold">{label}</span>
    </div>
  );
}

const statusInfo = {
  [TaskStatus.OPENED]: {
    label: "요청됨",
    value: TaskStatus.OPENED,
    color: "text-blue-B",
  },
  [TaskStatus.IN_PROGRESS]: {
    label: "진행중",
    value: TaskStatus.IN_PROGRESS,
    color: "text-dark-red",
  },
  [TaskStatus.CANCELED]: {
    label: "취소됨",
    value: TaskStatus.CANCELED,
    color: "text-pink",
  },
  [TaskStatus.REVIEW]: {
    label: "검토대기",
    value: TaskStatus.REVIEW,
    color: "text-purple-A",
  },
  [TaskStatus.CLOSED]: {
    label: "완료됨",
    value: TaskStatus.CLOSED,
    color: "text-green",
  },
};
